module.exports = __webpack_public_path__ + "opsgenie-logo.png";